import { Testids } from '@mono/ui-selectors';
const targets = {
    task: [
        Testids.capture.tasksRow,
        'data-task-id'
    ],
    theme: [
        Testids.capture.themeCard,
        'data-theme-id'
    ],
    area: [
        Testids.capture.planAreaRow,
        'data-area-id'
    ],
    'scoped-decision': [
        Testids.capture.goNoGoHistoryRow,
        'data-record-id'
    ],
    review: [
        Testids.captureReviews.row,
        'data-review-id'
    ]
};
// Compare attribute values directly: IDs are opaque, never selector syntax.
// Do not silently route an unknown record to a generic editor.
export function overviewTarget(root, destination) {
    if (!(destination.kind in targets)) return null;
    const [testid, attribute] = targets[destination.kind];
    return Array.from(root.querySelectorAll(`[data-testid="${testid}"]`)).find((element)=>element.getAttribute(attribute) === destination.id) ?? null;
}
export function overviewUrl(path, destination) {
    const params = new URLSearchParams({
        overviewKind: destination.kind,
        overviewId: destination.id
    });
    return `${path}?${params}`;
}
